import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Services } from '../../components/index';
import { getAsync, putAsync } from '../../redux/modules/services';

class ServicesForm extends PureComponent {

  getData() {
    this.props.getAsync();
  }

  componentDidMount() {
    this.getData()
  }

  handlerSubmit(values) {
    return this.props.putAsync(values);
  }

  render() {
    const { services } = this.props;
    return (
      <div className="planet-form">
        <section>
          <Services services={services}/>
        </section>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      services: state.services.values
    };
  },
  (dispatch) => {
    return bindActionCreators({ getAsync, putAsync }, dispatch);
  }
)(ServicesForm);



// WEBPACK FOOTER //
// ./src/forms/services/ServicesForm.js